import { MatStepperModule } from '@angular/material/stepper';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedModule } from './../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {
  NbMenuModule,
  NbCardModule,
  NbButtonModule,
  NbTabsetModule,
  NbAccordionModule,
  NbDialogModule,
  NbCalendarModule,
  NbDatepickerModule,
  NbInputModule,
  NbTreeGridModule,
  NbSelectModule,
  NbWindowModule,
  NbToggleModule,
  NbIconModule,
  NbStepperModule,
} from '@nebular/theme';
import { AdministrationRoutingRoutingModule } from './administration-routing.module';
import { ThemeModule } from '../../@theme/theme.module';
import { ServicesComponent } from './services/components/get-services/services.component';
import { PoliciesComponent } from './policies/components/get-policies/policies.component';
import { QuestionsComponent } from './questions/components/get-questions/questions.component';
import { SettingsComponent } from './settings/components/get-settings/settings.component';
import { ServicesVersionsComponent } from './services-versions/components/get-services-version/services-versions.component';
import { RatingComponent } from './rating/components/get-rates/rating.component';
import { ImprovementPlanComponent } from './improvement-plan/components/get-improvement-plan/improvement-plan.component';
import { AdministrationComponent } from './administration.component';
import { ServiceDetailComponent } from './services/components/service-detail/service-detail.component';
import { VideoComponent } from './videos/components/video/video.component';
import { VersionsComponent } from './versions/components/get-versions/versions.component';
import { AddVersionComponent } from './versions/components/add-version/add-version.component';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { AddVedioComponent } from './videos/components/add-vedio/add-vedio.component';

import { ServiceTypeComponent } from './services-type/components/get-service-types/service-type.component';
import { AddServiceTypeComponent } from './services-type/components/add-service-type/add-service-type.component';
import { HomeComponent } from './home/components/get-home/home.component';
import { BenefeciariesComponent } from './beneficiaries/components/get-beneficiaries/benefeciaries.component';
import { EmailContactComponent } from './email-contact/components/get-email-contacts/email.contact.component';
import { ContactComponent } from './contacts/components/get-email-contacts/contact.component';
import { AddRateCategoryComponent } from './services/components/service-rates/add-rate/add-rate-category.component';
import { RatesCommentsComponent } from './rating/components/rates-comments/rates-comments.component';
import { AddServiceComponent } from './services/components/add-service/add-service.component';
import { ServiceRatesComponent } from './services/components/service-rates/rates/service-rates.component';
import { AddQuestionComponent } from './questions/components/add-question/add-question.component';
import { ServiceQuestionComponent } from './questions/components/get-service-question/service-question.component';
import { AddbeneficiariesComponent } from './beneficiaries/components/add-beneficiaries/add-beneficiaries.component';
import { WorkFlowModule } from '../workFlowModule/work-flow/work-flow.module';

import { StarRatingModule } from 'angular-rating-star';
import { UpdateServiceComponent } from './services/components/update-service/update-service.component';
import { UpdateQuestionComponent } from './questions/components/update/update-question.component';
import { UpdateVedioComponent } from './videos/components/update-vedio/update-vedio.component';
import { UpdateRateCategoryComponent } from './services/components/service-rates/update-rate/update-rate-category.component';
import { UpdateServiceTypeComponent } from './services-type/components/update-service-type/update-service-type.component';
import { UpdatebeneficiariesComponent } from './beneficiaries/components/update/update-beneficiaries.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DynamicFormsModule } from '../DynamicFormsModule/dynamicForms.module';
import { AboutComponent } from './about/components/add-about/about.component';
import { GetManagementsComponent } from './management-info/components/get-managements/get-managements.component';
import { GetNewsComponent } from './news/components/get-news/news.component';
import { GetEventsComponent } from './events/components/get-events/events.component';
import { GetBlogsComponent } from './blogs/components/get-blogs/blogs.component';
import { GetBoardOfTrusteesComponent } from './board-of-trustees/components/get-board-of-trustees/get-board-of-trustees.component';
import { GetCommittesComponent } from './committees/compoennts/get-committes/get-committes.component';
import { GetLibrariesComponent } from './libraries/components/get-libraries/get-libraries.component';
import { GetRegulationsComponent } from './regulations/components/get-regulations/get-regulations.component';
import { GetAcheivementsComponent } from './achievements/components/get-acheivements/get-acheivements.component';
import { GetReportsComponent } from './reports/components/get-reports/get-reports.component';
import { GetCooperationComponent } from './cooperation/components/get-cooperation/get-cooperation.component';
import { AddNewsComponent } from './news/components/add-news/add-news.component';
import { AddManagementComponent } from './management-info/components/add/add-management/add-management.component';
import { AddEventComponent } from './events/components/add-event/add-event.component';
import { AddBlogComponent } from './blogs/components/add-blog/add-blog.component';
import { AddBoardOfTrusteeComponent } from './board-of-trustees/components/add-board-of-trustee/add-board-of-trustee.component';
import { AddCommitteComponent } from './committees/compoennts/add-committe/add-committe.component';
import { AddLibraryComponent } from './libraries/components/add-library/add-library.component';
import { GetManagementDetailsComponent } from './management-info/components/get-management-details/get-management-details.component';
import { GetNewsDetailsComponent } from './news/components/get-news-details/get-news-details.component';
import { GetEventDetailsComponent } from './events/components/get-event-details/get-event-details.component';
import { GetBlogsDetailsComponent } from './blogs/components/get-blogs-details/get-blogs-details.component';
import { GetBoardOfTrusteeDetailsComponent } from './board-of-trustees/components/get-board-of-trustee-details/get-board-of-trustee-details.component';
import { GetLibraryDetailsComponent } from './libraries/components/get-library-details/get-library-details.component';
import { GetCommitteDetailsComponent } from './committees/compoennts/get-committe-details/get-committe-details.component';
import { RegulationDetailsComponent } from './regulations/components/regulation-details/regulation-details.component';
import { AddRegulationComponent } from './regulations/components/add-regulation/add-regulation.component';
import { AddReportComponent } from './reports/components/add-report/add-report.component';
import { GetReportDetailsComponent } from './reports/components/get-report-details/get-report-details.component';
import { AddAcheivementComponent } from './achievements/components/add-acheivement/add-acheivement.component';
import { AchievementDetailsComponent } from './achievements/components/achievement-details/achievement-details.component';
import { CooperationDetailsComponent } from './cooperation/components/cooperation-details/cooperation-details.component';
import { AddCooperationComponent } from './cooperation/components/add-cooperation/add-cooperation.component';
import { GetUsersComponentComponent } from './users/components/get-users-component/get-users-component.component';
import { GetRolesComponentComponent } from './roles/components/get-roles-component/get-roles-component.component';
import { AddRoleComponent } from './roles/components/add-role/add-role.component';
import { EditUserRolesComponent } from './users/components/edit-user-roles/edit-user-roles.component';
import { GetControlPipe } from '../shared/pipes/getControl.pipe';
import { AddUserComponent } from './users/components/add-user/add-user.component';
import { AddComplexAttachementsComponent } from './complex-attachements/components/add-complex-attachements/add-complex-attachements.component';
import { GetComplexAttachementsComponent } from './complex-attachements/components/get-complex-attachements/get-complex-attachements.component';
import { ComplexAttachementsDetailsComponent } from './complex-attachements/components/complex-attachements-details/complex-attachements-details.component';
import { AddDspaceComponent } from './dspace/components/add-dspace/add-dspace.component';
import { DspaceDetailsComponent } from './dspace/components/dspace-details/dspace-details.component';
import { GetDspaceComponent } from './dspace/components/get-dspace/get-dspace.component';
import { GetDspaceStatisticsComponent } from './dspace-statistics/components/get-dspace-statistics/get-dspace-statistics.component';
import { AddDspaceStatisticsComponent } from './dspace-statistics/components/add-dspace-statistics/add-dspace-statistics.component';
import { GetComplexInfoComponent } from './complex-info/components/get-complex-info/get-complex-info.component';
import { CreateComplexInfoComponent } from './complex-info/components/create-complex-info/create-complex-info.component';
import { GetEmergencyCallsComponent } from './emergency-calls/components/get-emergency-calls/get-emergency-calls.component';
import { AddEmergencyCallsComponent } from './emergency-calls/components/add-emergency-calls/add-emergency-calls.component';
import { GetVisitTypesComponent } from './complex-visit-types/components/get-visit-types/get-visit-types.component';
import { AddVisitTypeComponent } from './complex-visit-types/components/add-visit-type/add-visit-type.component';
import { GetPartnerComponent } from './partners/components/get-partner/get-partner.component';
import { AddPartnerComponent } from './partners/components/add-partner/add-partner.component';
import { PartnerDetailsComponent } from './partners/components/partner-details/partner-details.component';
import { GetAppInfoComponent } from './app-info/components/get-app-info/get-app-info.component';
import { AddAppInfoComponent } from './app-info/components/add-app-info/add-app-info.component';
import { AppInfoDetailsComponent } from './app-info/components/app-info-details/app-info-details.component';
import { AddCentersComponent } from './Centers/Components/add-centers/add-centers.component';
import { CentersDetailsComponent } from './Centers/Components/centersdetails/centersdetails.component';
import { GetCentersComponent } from './Centers/Components/get-centersdetails/get-centersdetails.component';
import { AddPortalsComponent } from './Portals/Components/add-portals/add-portals.component';
import { GetPortalsDetailsComponent } from './Portals/Components/get-portals/get-portals.component';
import { PortalsDetailsComponent } from './Portals/Components/portaldetails/portaldetails.component';
import { GetInstitutionsComponent } from './Institution/Components/get-institution/get-institution.component';
import { AddInstitutionComponent } from './Institution/Components/add-institution/add-institution.component';
import { InstitutionDetailsComponent } from './Institution/Components/institution-details/institution-details.component';
import { GetUserProfileComponent } from './ProfileInfo/Components/get-user-profile/get-user-profile.component';
import { GetPageRolesComponent } from './PageRoles/Components/get-page-roles/get-page-roles.component';
import { PageRolesDetailsComponent } from './PageRoles/Components/page-roles-details/page-roles-details.component';
import { AddPageRolesComponent } from './PageRoles/Components/add-page-roles/add-page-roles.component';
import { AddElectronicSharingComponent } from './electronic-sharing/components/add-electronic-sharing/add-electronic-sharing.component';
import { GetElectronicSharingComponent } from './electronic-sharing/components/get-electronic-sharing/get-electronic-sharing.component';
import { GetElectronicSharingDetailsComponent } from './electronic-sharing/components/get-electronic-sharing-details/get-electronic-sharing-details.component';
import { AddElectronicConsultationComponent } from './electronic-consultation/components/add-electronic-consultation/add-electronic-consultation.component';
import { GetElectronicConsultationComponent } from './electronic-consultation/components/get-electronic-consultation/get-electronic-consultation.component';
import { GetElectronicConsultationDetailsComponent } from './electronic-consultation/components/get-electronic-consultation-details/get-electronic-consultation-details.component';
import { GetOpenDataComponent } from './open-data/components/get-open-data/get-open-data.component';
import { AddOpenDataComponent } from './open-data/components/add-open-data/add-open-data.component';
import { GetOpenDataDetailsComponent } from './open-data/components/get-open-data-details/get-open-data-details.component';
import { GetContactUsMessagesComponent } from './contact-us-messages/components/get-contact-us-messages/get-contact-us-messages.component';
import { ContactUsMessageDetailsComponent } from './contact-us-messages/components/contact-us-message-details/contact-us-message-details.component';
import { GetRequestLoggingsComponent } from './request-logging/components/get-request-loggings/get-request-loggings.component';
import { RequestLoggingDetailsComponent } from './request-logging/components/request-logging-details/request-logging-details.component';
import { ContactUsMessageReplyComponent } from './contact-us-messages/components/contact-us-message-reply/contact-us-message-reply.component';
import { DeleteConfirmationComponent } from './delete-confirmation/delete-confirmation.component';

@NgModule({
  imports: [
    AdministrationRoutingRoutingModule,
    ThemeModule,
    NbMenuModule,
    NbCardModule,
    NbButtonModule,
    NbTabsetModule,
    NbAccordionModule,
    RichTextEditorAllModule,
    NbDialogModule.forChild(),
    NbCalendarModule,
    NbDatepickerModule,
    NbInputModule,
    FormsModule,
    NbTreeGridModule,
    NbSelectModule,
    WorkFlowModule,
    DynamicFormsModule,
    SharedModule,
    StarRatingModule,
    NbWindowModule.forChild(),
    NbToggleModule,
    NgxChartsModule,
    NbIconModule,
    NbStepperModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
  ],
  declarations: [
    ServicesComponent,
    PoliciesComponent,
    QuestionsComponent,
    SettingsComponent,
    ServicesVersionsComponent,
    RatingComponent,
    ImprovementPlanComponent,
    AdministrationComponent,
    ServiceDetailComponent,
    VideoComponent,
    VersionsComponent,
    AddVersionComponent,
    AddVedioComponent,
    ServiceRatesComponent,
    ServiceTypeComponent,
    AddServiceTypeComponent,
    HomeComponent,
    BenefeciariesComponent,
    EmailContactComponent,
    ContactComponent,
    AddRateCategoryComponent,
    RatesCommentsComponent,
    AddServiceComponent,
    AddQuestionComponent,
    ServiceQuestionComponent,
    AddbeneficiariesComponent,
    UpdateServiceComponent,
    UpdateQuestionComponent,
    UpdateVedioComponent,
    UpdateRateCategoryComponent,
    UpdateServiceTypeComponent,
    UpdatebeneficiariesComponent,
    AboutComponent,
    GetManagementsComponent,
    GetNewsComponent,
    GetEventsComponent,
    GetBlogsComponent,
    GetBoardOfTrusteesComponent,
    GetCommittesComponent,
    GetLibrariesComponent,
    GetRegulationsComponent,
    GetAcheivementsComponent,
    GetReportsComponent,
    GetCooperationComponent,
    AddNewsComponent,
    AddManagementComponent,
    AddEventComponent,
    AddBlogComponent,
    AddBoardOfTrusteeComponent,
    AddCommitteComponent,
    AddLibraryComponent,
    GetManagementDetailsComponent,
    GetNewsDetailsComponent,
    GetEventDetailsComponent,
    GetBlogsDetailsComponent,
    GetBoardOfTrusteeDetailsComponent,
    GetLibraryDetailsComponent,
    GetCommitteDetailsComponent,
    AddRegulationComponent,
    RegulationDetailsComponent,
    AddReportComponent,
    GetReportDetailsComponent,
    AddAcheivementComponent,
    AchievementDetailsComponent,
    CooperationDetailsComponent,
    AddCooperationComponent,
    GetUsersComponentComponent,
    GetRolesComponentComponent,
    AddRoleComponent,
    EditUserRolesComponent,
    AddUserComponent,
    AddComplexAttachementsComponent,
    GetComplexAttachementsComponent,
    ComplexAttachementsDetailsComponent,
    AddDspaceComponent,
    GetDspaceComponent,
    DspaceDetailsComponent,
    GetDspaceStatisticsComponent,
    AddDspaceStatisticsComponent,
    GetComplexInfoComponent,
    CreateComplexInfoComponent,
    AddEmergencyCallsComponent,
    GetEmergencyCallsComponent,
    GetVisitTypesComponent,
    AddVisitTypeComponent,
    GetPartnerComponent,
    AddPartnerComponent,
    PartnerDetailsComponent,
    GetAppInfoComponent,
    AddAppInfoComponent,
    AppInfoDetailsComponent,
    AddCentersComponent,
    CentersDetailsComponent,
    GetCentersComponent,
    AddPortalsComponent,
    GetPortalsDetailsComponent,
    PortalsDetailsComponent,
    GetInstitutionsComponent,
    AddInstitutionComponent,
    InstitutionDetailsComponent,
    GetUserProfileComponent,
    GetPageRolesComponent,
    PageRolesDetailsComponent,
    AddPageRolesComponent,
    AddElectronicSharingComponent,
    GetElectronicSharingComponent,
    GetElectronicSharingDetailsComponent,
    AddElectronicConsultationComponent,
    GetElectronicConsultationComponent,
    GetElectronicConsultationDetailsComponent,
    GetOpenDataComponent,
    AddOpenDataComponent,
    GetOpenDataDetailsComponent,
    GetContactUsMessagesComponent,
    ContactUsMessageDetailsComponent,
    GetRequestLoggingsComponent,
    RequestLoggingDetailsComponent,
    ContactUsMessageReplyComponent,
    DeleteConfirmationComponent,
 
  ],
  entryComponents: [
    ContactUsMessageReplyComponent,
    AddServiceComponent,
    AddQuestionComponent,
    AddVersionComponent,
    AddServiceTypeComponent,
    UpdateServiceComponent,
    UpdateQuestionComponent,
    UpdateVedioComponent,
    UpdateRateCategoryComponent,
    UpdateServiceTypeComponent,
    UpdatebeneficiariesComponent,
    AddVedioComponent,
    AddRateCategoryComponent,
    AddbeneficiariesComponent,
    AddNewsComponent,
    AddManagementComponent,
    AddEventComponent,
    AddBlogComponent,
    AddBoardOfTrusteeComponent,
    AddCommitteComponent,
    AddLibraryComponent,
    GetManagementDetailsComponent,
    GetNewsDetailsComponent,
    GetEventDetailsComponent,
    GetBlogsDetailsComponent,
    GetBoardOfTrusteeDetailsComponent,
    GetLibraryDetailsComponent,
    GetCommitteDetailsComponent,
    AddRegulationComponent,
    RegulationDetailsComponent,
    AddReportComponent,
    GetReportDetailsComponent,
    AddAcheivementComponent,
    AchievementDetailsComponent,
    CooperationDetailsComponent,
    AddCooperationComponent,
    AddRoleComponent,
    EditUserRolesComponent,
    AddUserComponent,
    AddComplexAttachementsComponent,
    ComplexAttachementsDetailsComponent,
    AddDspaceComponent,
    DspaceDetailsComponent,
    AddDspaceStatisticsComponent,
    GetComplexInfoComponent,
    CreateComplexInfoComponent,
    AddEmergencyCallsComponent,
    GetEmergencyCallsComponent,
    AddVisitTypeComponent,
    PartnerDetailsComponent,
    AddPartnerComponent,
    GetAppInfoComponent,
    AddAppInfoComponent,
    AppInfoDetailsComponent,
    AddCentersComponent,
    CentersDetailsComponent,
    AddPortalsComponent,
    GetPortalsDetailsComponent,
    PortalsDetailsComponent,
    AddInstitutionComponent,
    InstitutionDetailsComponent,
    GetPageRolesComponent,
    AddPageRolesComponent,
    PageRolesDetailsComponent,
    AddElectronicSharingComponent,
    GetElectronicSharingDetailsComponent,
    AddElectronicConsultationComponent,
    GetElectronicConsultationDetailsComponent,
    AddOpenDataComponent,
    GetOpenDataDetailsComponent,
    ContactUsMessageDetailsComponent,
    RequestLoggingDetailsComponent,
    DeleteConfirmationComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdministrationModule {}
